import { render, staticRenderFns } from "./OfferExtrasView.vue?vue&type=template&id=21b92a31"
import script from "./OfferExtrasView.vue?vue&type=script&lang=js"
export * from "./OfferExtrasView.vue?vue&type=script&lang=js"
import style0 from "./OfferExtrasView.vue?vue&type=style&index=0&id=21b92a31&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports